import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import config from "../utils/config";
import placeholder from "../assets/placeholder.png";

const Navbar = () => {
	const [open, setOpen] = useState(false);

	return (
		<nav className="navbar">
			<div className="nav-bar">
				<img src={placeholder} alt="TumoScamOY" className="brand" />

				<ul className={`topnav ${open ? "open" : ""}`}>
					<li><Link to="/" onClick={() => setOpen(false)}>Home</Link></li>
					<li><Link to="/kapanen" onClick={() => setOpen(false)}>Timetable</Link></li>
					<li><Link to="/recruiting" onClick={() => setOpen(false)}>Recruiting</Link></li>

					<li className="dropdown">
						<span className="dropbtn">Discord Bot</span>
						<div className="dropdown-content">
							<a
								href={config.EXTERNAL_URLS.KOWALSKI}
								target="_blank"
								rel="noopener noreferrer">
								Kowalski
							</a>
							<a
								href={config.EXTERNAL_URLS.KOWALSKIBETA}
								target="_blank"
								rel="noopener noreferrer">
								Kowalski BETA
							</a>
						</div>
					</li>
				</ul>

				<button
				className="hamburger"
				onClick={() => setOpen(!open)}
				aria-label="Toggle navigation"
				>
					☰
				</button>
			</div>
		</nav>
	)
}

export default Navbar;